import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import AuthModal from './AuthModal';
import './Navigation.css';

function Navigation() {
  const { isDarkMode, toggleTheme } = useTheme();
  const { user, logout, isAdmin, isAuthenticated } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('login');
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  // Auto-open login modal when ?login=true (e.g. after email verification)
  useEffect(() => {
    if (searchParams.get('login') === 'true' && !isAuthenticated) {
      setAuthMode('login');
      setShowAuthModal(true);
      searchParams.delete('login');
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, isAuthenticated]);

  const handleAuthClick = (mode) => {
    setAuthMode(mode);
    setShowAuthModal(true);
    setMenuOpen(false);
  };

  // Close menu on navigation
  const handleNavClick = () => {
    setMenuOpen(false);
  };

  // Close menu on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 640) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo-section">
            <Link to="/" className="nav-logo" onClick={handleNavClick}>
              dichtlicht.de
            </Link>
            <button 
              className="theme-toggle" 
              onClick={toggleTheme}
              title={isDarkMode ? 'Zu Light Mode wechseln' : 'Zu Dark Mode wechseln'}
              aria-label="Farbmodus wechseln"
            >
              {isDarkMode ? '☀️' : '🌙'}
            </button>
            <button 
              className="menu-toggle show-mobile"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menü öffnen/schließen"
              aria-expanded={menuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <div className={`nav-menu ${menuOpen ? 'active' : ''}`}>
            <Link to="/" className="nav-link" onClick={handleNavClick}>
              🔍 Suche
            </Link>
            <Link to="/comparison" className="nav-link" onClick={handleNavClick}>
              ⚖️ Vergleich
            </Link>
            <Link to="/sale" className="nav-link" onClick={handleNavClick}>
              💰 SALE
            </Link>
            <Link to="/shops" className="nav-link" onClick={handleNavClick}>
              🏪 Trust
            </Link>
            <Link to="/forum" className="nav-link" onClick={handleNavClick}>
              💬 Forum
            </Link>
            
            {isAuthenticated ? (
              <>
                <Link to="/profile" className="nav-link profile-link" title="Mein Profil" onClick={handleNavClick}>
                  {user.profileImage ? (
                    <img src={user.profileImage} alt={user.username} className="nav-profile-img" />
                  ) : (
                    <span className="nav-profile-placeholder">👤</span>
                  )}
                  <span className="show-mobile">{user.username}</span>
                </Link>
                {isAdmin && (
                  <Link to="/admin" className="nav-link admin-link" onClick={handleNavClick}>
                    🔐 Admin
                  </Link>
                )}
                <button onClick={() => { logout(); setMenuOpen(false); }} className="nav-link nav-btn">
                  Abmelden
                </button>
              </>
            ) : (
              <button onClick={() => handleAuthClick('login')} className="nav-link nav-btn nav-signup">
                Anmelden
              </button>
            )}
          </div>
        </div>
      </nav>
      
      <AuthModal 
        isOpen={showAuthModal} 
        onClose={() => setShowAuthModal(false)}
        mode={authMode}
      />
    </>
  );
}

export default Navigation;
